.form {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  min-width: 32rem;
}
